module.exports = __webpack_public_path__ + "img/rooster-3.9e1bd6e9.png";